<i
    class="loading-circle"
    [class.first]="!animationsDisabled"></i>
<i
    class="loading-circle"
    [class.middle]="!animationsDisabled"></i>
<i
    class="loading-circle"
    [class.last]="!animationsDisabled"></i>
